module.exports = __webpack_public_path__ + "img/animals_02_H.16f760e2.webp";